import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay so it doesn't flash immediately on first load
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 shadow-xl"
    >
      <div className="container-custom py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Cookie className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5 sm:mt-0" />

          <p className="text-sm text-gray-700 dark:text-zinc-300 flex-1">
            We use cookies to improve your experience and display relevant ads. See our{' '}
            <Link to="/legal/privacy" className="text-brand-600 dark:text-brand-400 hover:underline">
              Privacy Policy
            </Link>{' '}
            for details. Non-essential cookies are only loaded with your consent.
          </p>

          <div className="flex items-center gap-3 flex-shrink-0 self-stretch sm:self-auto">
            <button
              onClick={reject}
              className="btn-ghost text-sm px-4 py-2"
            >
              Reject
            </button>
            <button
              onClick={accept}
              className="btn-primary text-sm px-5 py-2"
            >
              Accept All
            </button>
            <button
              onClick={reject}
              aria-label="Dismiss"
              className="text-gray-400 hover:text-gray-600 dark:text-zinc-600 dark:hover:text-zinc-400 ml-1"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
